<template>
<div class="sell-plan" :style="{'width': clientWidth + 'px', 'height': clientHeight + 'px'}">
    <div class="content clearfix">
        <div v-for="(item, index) in productListArr" :key="index" class="product-pannel">
            <div class="title">{{item.pl_name}}</div>
            <div class="compare">
                <div class="month-compare">当月同期对比：<span class="compare-num">{{parseInt(item.pl_sales.contrast_same_month * 100)+'%'}}</span></div>
                <!-- <div class="month-compare">当月同期对比：<span class="compare-num">100%</span></div> -->
                <div class="sum-compare">累计同期对比：<span class="compare-num">{{parseInt(item.pl_sales.contrast_total * 100)+'%'}}</span></div>
            </div>
            <!-- <div class="month-complete">
                <span class="square"></span>
                <span class="text">当月任务完成率</span>
            </div>
            <div class="year-complete">
                <span class="square"></span>
                <span class="text">年预算完成率</span>
            </div>
             <div class="no-complete">
                <span class="square"></span>
                <span class="text">未完成率</span>
            </div> -->
            <div :id="'circle' + index"></div>
            <div :id="'circle' + index + index"></div>
            <div class="year-direction">
                <span class="year-direction-num">{{parseInt(item.pl_sales.completion_rate_year * 100)}}%</span>
            </div>
            <div class="month-direction">
                <span class="month-direction-num">{{parseInt(item.pl_sales.completion_rate_month * 100)}}%</span>
            </div>
            <div class="month-complete-text">当月任务完成率</div>
            <div class="year-complete-text">年预算完成率</div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            clientWidth: '',
            clientHeight: '',
            productListArr: [],
            tempOption: {
                series: [
                    {
                        // name: '访问来源',#334B5C
                        // #FE5500   
                        color: ['#ffce86','#fff', ],
                        type: 'pie',
                        radius : '55%',
                        center: ['50%', '60%'],
                        label: {
                            normal: {
                                position: 'inner'
                            }
                        },
                        data:[
                            {value:335},
                            {value:310},
                        ],
                    }
                ]
            },
        }
    },
    created() {
        this.clientWidth = document.documentElement.clientWidth;
        this.clientHeight = document.documentElement.clientHeight;
        parseInt()
        this.axios.get('https://xarh.sprucesmart.com/api/v2/sales_completion')
        .then(res => {
            res.data.pl_data.forEach((item,index) => {
                var monthRate = parseInt(item.pl_sales.completion_rate_month * 100);
                var yearRate = parseInt(item.pl_sales.completion_rate_year * 100);
                // console.log('yearRate: ', item.completion_rate_year * 100)
                if((100 - monthRate) <= 0) {
                    item.monthComplete = 100;
                    item.monthNoComplete = 0;
                }
                else {
                    item.monthComplete = monthRate;
                    item.monthNoComplete = 100 - monthRate;
                }
                if((100 - yearRate) <= 0) {
                    item.yearComplete = 100;
                    item.yearNoComplete = 0;
                }
                else {
                    item.yearComplete = yearRate;
                    item.yearNoComplete = 100 - yearRate;
                }
            })
            this.productListArr = res.data.pl_data;
            this.$nextTick(() => {
                this.productListArr.forEach((item, index) => {
                    console.log(item)
                    var option1 = JSON.parse(JSON.stringify(this.tempOption));
                    option1.series[0].data[0].value = item.monthComplete
                    option1.series[0].data[1].value = item.monthNoComplete
                    if(item.monthComplete == 0) {
                        option1.series[0].data[0].name = ''
                    }
                    if(item.monthNoComplete == 0) {
                        option1.series[0].data[1].name = ''
                    }
                    var myChart1 = this.$echarts.init(document.getElementById('circle'+index));
                    myChart1.setOption(option1);

                    var option2 = JSON.parse(JSON.stringify(this.tempOption));
                    option2.series[0].data[0].value = item.yearComplete
                    option2.series[0].data[1].value = item.yearNoComplete
                    // #4ac6f4 
                    option2.series[0].color = ['#5dcdd0','#fff',];
                    if(item.monthComplete == 0) {
                        option2.series[0].data[0].name = ''
                    }
                    if(item.monthNoComplete == 0) {
                        option2.series[0].data[1].name = ''
                    }
                    var myChart2 = this.$echarts.init(document.getElementById('circle'+index + index));
                    myChart2.setOption(option2);
                })
            })
        })
    },
    methods: {
/**
 * 
 */
    }
}
</script>

<style scoped>
.sell-plan {
    position: relative;
    /* margin-bottom: 40px; */
    padding-top: 60px;
    background-color: #FCFCFC;
}

.content {
    width: 1200px;
    margin: 0 auto;
    background-color: #aaa;
}

.product-pannel {
    float: left;
    position: relative;
    width: 340px;
    height: 280px;
    padding: 0 24px;
    margin-right: 10px;
    margin-bottom: 80px;
    background-color: #fff;
    border-radius: 12px;
}

.title {
    position: absolute;
    width: 100%;
    left: 0;
    top: -35px;
    text-align: center;
    font-size: 20px;
    color: #181818;
    line-height: 30px;
    font-weight: medium;
    font-family: "PingFangSC";
}

.compare {
    position: absolute;
    width: 100%;
    left: 16px;
    top: 25px;
}

.compare>div {
    display: inline-block;
    width: 171px;
    background-color: #00A8E7;
    color: #fff;
    font-size: 13px;
    text-align: center;
    line-height: 33px;
    border-radius: 4px;
}

.sum-compare {
    width: 132px;
    margin-left: 10px;
}

.month-complete,
.year-complete,
.no-complete {
    position: absolute;
    left: 20px;
    top: 80px;
    width: 100%;
    height: 20px;
    font-size: 14px;
    color: #181818;
    font-weight: regular;
}

.square {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    background-color: #00A8E7;
}

.text {
    position: relative;
    top: -5px;
    display: inline-block;
    height: 20px;
    line-height: 20px;
}

.year-complete {
    top: 115px;
}
.no-complete {
    top: 150px;
}

.year-complete>.square {
    background-color: #FF5500;
}
.no-complete > .square {
    background-color: #334B5C;
}

#circle0,
#circle1,
#circle2,
#circle3,
#circle4,
#circle5,
#circle6,
#circle7,
#circle00,
#circle11,
#circle22,
#circle33,
#circle44,
#circle55,
#circle66,
#circle77
 {
    position: absolute;
    right: -16px;
    bottom: 30px;
    width: 220px;
    height: 220px;
}
#circle00,
#circle11,
#circle22,
#circle33,
#circle44,
#circle55,
#circle66,
#circle77
 {
    right: 170px;
}
.month-complete-text,
.year-complete-text {
    position: absolute;
    right: 42px;
    bottom: 10px;
    width: 120px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #222;
    font-size: 16px;
}
.year-complete-text {
    right: 221px;
}
.compare-num {
    font-size: 28px;
}
.year-direction,
.month-direction {
    position: absolute;
    bottom: 118px;
    left: 38px;
    width: 70px;
    height: 39px;
    background-image: url(../../../assets/imgs/zhiyinxian.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
}
.month-direction {
    left: 224px;
}
.year-direction-num,
.month-direction-num {
    position: absolute;
    left: -45px;
    top: -10px;
}

</style>



// WEBPACK FOOTER //
// src/pages/dataBoard/bigDataBoard/SellPlan.vue